
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#e53429","d":"M0 0h40v40H0z"}}),_c('path',{attrs:{"d":"M16 17.3v6.5h-1.1v-6.5h-2.3v-1.1h5.8v1.1H16zM5.9 21.5H7c.2.9 1.2 1.3 2.3 1.3.9 0 2.1-.4 2.1-1.2 0-.9-1-1.1-2.3-1.4-1.4-.3-2.9-.6-2.9-2.1C6.2 16.8 7.8 16 9 16c1.4 0 2.7.5 3.1 1.9H11c-.4-.7-1.2-.9-2-.9-.9 0-1.7.4-1.7 1 0 .7.9 1 2 1.2 1.5.3 3.2.6 3.2 2.3 0 1.4-1.5 2.3-3.2 2.3-1.5.1-3.1-.5-3.4-2.3m24.6 2.4c-2.2 0-3.9-1.8-3.9-3.9 0-2.2 1.8-3.9 3.9-3.9 1.6 0 3 .9 3.6 2.4h-1.2c-.5-.8-1.4-1.3-2.4-1.3-1.6 0-2.8 1.3-2.8 2.8 0 1.6 1.3 2.8 2.8 2.8 1 0 1.8-.5 2.4-1.3h1.2c-.7 1.5-2 2.4-3.6 2.4M24.8 20c0-1.5-1.2-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.8 0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8m0-3.7h1.1v7.5h-1.1v-1.2c-.6.9-1.7 1.3-2.7 1.3-2.2 0-3.9-1.8-3.9-3.9 0-2.2 1.8-3.9 3.9-3.9 1 0 2.1.4 2.7 1.3v-1.1z","fill":"#fff"}})])
          )
        }
      }
    